import React, { useState } from "react";

import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
  Typography,
  FormControl,
} from "@mui/material";

import SaveIcon from "@mui/icons-material/Save";
import LinkIcon from "@mui/icons-material/Link";
//constants
import Styles from "../../constants/styles.json";
import Color from "../../constants/colors.json";
import Language from "../../constants/language_fr.json";
//api
import Company from "../../api/company";
import { TextField } from "@mui/material";
export default function AddRequiredFields({
  companyInfo,
  userInfo,
  expanded,
  setExpanded,
  setSnackBar,
  setCompany,
  setActivityIndicator,
}) {
  let {
    config: { apiConnexions = {} },
  } = companyInfo || {};

  const [apiConnexionsState, setApiConnexionsState] = useState(apiConnexions);
  const [isDisabled, setIsDisabled] = useState(true);

  const handleChange = ({ key, value }) => {
    setIsDisabled(false);
    setApiConnexionsState({ ...apiConnexionsState, [key]: value });
  };

  const submitApiConnexions = async () => {
    setActivityIndicator({
      isOpen: true,
      message: Language.appBar.updateCompanyInProgress,
    });
    const { Update } = Company || {};
    const { token } = userInfo;
    const { config } = companyInfo;
    const _company = {
      ...companyInfo,
      config: { ...config, apiConnexions: apiConnexionsState },
    };
    const { status } = await Update({
      company: _company,
      token,
    });

    if (status === 200) {
      setIsDisabled(true);
      _company && setCompany(_company);
      _company && localStorage.setItem("company", JSON.stringify(_company));
      setSnackBar({
        isOpen: true,
        message: Language.snackBar.updateCompanySuccess,
        status: "success",
      });
    } else {
      setSnackBar({
        isOpen: true,
        message: Language.snackBar.updateCompanyError,
        status: "error",
      });
    }
    setActivityIndicator({ isOpen: false, message: null });
  };

  const connexions = [
    { key: "tikTrak", label: "TIK TRAK", placeholder: "Token" },
  ];

  return (
    <Accordion
      square
      style={{ width: "100%" }}
      expanded={expanded === "apiConnexions"}
      onChange={() =>
        expanded === "apiConnexions"
          ? setExpanded(null)
          : setExpanded("apiConnexions")
      }
    >
      <AccordionSummary
        style={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <LinkIcon style={{ color: Color.green }} />
        <Typography variant="subtitle1" style={{ marginLeft: "5px" }}>
          {Language.appBar.apiConnexions}
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <FormControl key="apiConnexions" style={{ width: "100%" }}>
          {connexions?.map(({ label, key, placeholder }) => (
            <TextField
              size="small"
              key={key}
              color="primary"
              label={label}
              placeholder={placeholder}
              variant="outlined"
              multiline
              maxRows={4}
              onChange={({ target }) =>
                handleChange({ key, value: target?.value })
              }
              value={apiConnexions?.[key]}
            />
          ))}

          <Button
            style={Styles.button}
            variant="contained"
            disabled={isDisabled}
            color="primary"
            onClick={() => submitApiConnexions()}
            type="submit"
            startIcon={<SaveIcon />}
          >
            {Language.appBar.add}
          </Button>
        </FormControl>
      </AccordionDetails>
    </Accordion>
  );
}
